import React from 'react';
import { Document, Page, Text, Image, StyleSheet, Font, View } from '@react-pdf/renderer';
import logo from '../../assets/images/login-logo.png';

const SingleQRCode = ({ qr_data }) => {
    return (
        <Document>
            <Page style={styles.body}>
                <Image style={styles.image} src={logo} />
                <View style={styles.mainContainer}>
                    <Text style={styles.header}>QR Code's Data</Text>
                    <View style={styles.headerRow}>
                        <View style={styles.data_fields}>
                            <Text style={styles.title}>Name</Text>
                            <Text style={styles.subtitle}>{qr_data.name || 'N/A'}</Text>
                        </View>
                    </View>
                </View>
                <Image style={styles.image} src={qr_data?.qrCode} />
            </Page>
        </Document>
    );
};

Font.register({
    family: 'Oswald',
    src: 'https://fonts.gstatic.com/s/oswald/v13/Y_TKV6o8WovbUd3m_X9aAA.ttf'
});

const styles = StyleSheet.create({
    body: {
        paddingTop: 25,
        paddingBottom: 65,
        paddingHorizontal: 35
    },
    mainContainer: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'center',
        alignItems: 'center'
    },
    title: {
        fontSize: 14,
        textAlign: 'start',
        fontFamily: 'Oswald'
    },
    subtitle: {
        fontSize: 12,
        fontFamily: 'Oswald',
        color: '#505050',
        fontWeight: 'bold'
    },
    image: {
        marginVertical: 15,
        marginHorizontal: 100
    },
    header: {
        fontSize: 18,
        marginBottom: 20,
        textAlign: 'center',
        color: 'black',
        fontWeight: 'semibold'
    },
    pageNumber: {
        position: 'absolute',
        fontSize: 12,
        bottom: 30,
        left: 0,
        right: 0,
        textAlign: 'center',
        color: 'grey'
    },
    headerRow: {
        display: 'flex',
        justifyContent: 'space-evenly',
        gap: '5px',
        alignItems: 'center',
        flexDirection: 'column',
        flexWrap: 'wrap'
    },
    data_fields: {
        display: 'flex',
        justifyContent: 'space-between',
        gap: '20px',
        alignItems: 'center',
        flexWrap: 'wrap',
        flexDirection: 'row',
        width: '450px',
        borderBottom: '1px solid black',
        padding: '5px'
    }
});

export default SingleQRCode;
